module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-cascader', {
    ref: "cascader",
    staticClass: "arriveClass orgList",
    staticStyle: {
      "margin-right": "16px"
    },
    attrs: {
      "placeholder": _vm.Language('部门'),
      "show-all-levels": false,
      "clearable": "",
      "filterable": "",
      "options": _vm.orgList,
      "props": {
        expandTrigger: 'hover',
        label: 'orgName',
        value: 'orgId',
        checkStrictly: true
      },
      "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return'
    },
    on: {
      "change": _vm.orgChange
    },
    model: {
      value: (_vm.orgId),
      callback: function($$v) {
        _vm.orgId = $$v
      },
      expression: "orgId"
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "arriveClass userList",
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": _vm.Language('人员'),
      "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return'
    },
    model: {
      value: (_vm.userId),
      callback: function($$v) {
        _vm.userId = $$v
      },
      expression: "userId"
    }
  }, _vm._l((_vm.userList), function(item) {
    return _c('el-option', {
      key: item.userId,
      attrs: {
        "label": item.agentName,
        "value": item.userId + ''
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-0ba9005b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/Sass/components/DepartPersonSelect.vue
// module id = 1320
// module chunks = 5